// @ts-nocheck
import InfosFetcher from "components/InfosFetcher/InfosFetcher";
import AuthorPreview from "components/User/AuthorPreview/AuthorPreview";
import genRequest from "includes/request";
import { t } from "i18next";
import React from "react";
import moment from "moment";
export default function ReportPreview({ report }) {
	let parsed = {};
	try { parsed = JSON.parse(report.txt); } catch(e) {}

	return (
		<div className="overflow-auto">
			<div>
				<h3>{t('Reporting.TITLE')}</h3>
				<b>{report.address}</b>
				<br />
				{moment(report.publishedDate).format(t("Events.DATE_TIME_FORMAT"))}
			</div>
			<hr />
			<div>
				<h5>{t('Reporting.REQUEST')}</h5>
				<b>{parsed?.method?.toUpperCase()} - {parsed?.status || parsed?.error?.status}</b>
				<div>{parsed.url}</div>
			</div>
			<hr />
			<UserPreview report={report} datas={parsed} />
			<hr />
			<details>
				<summary>{t('Reporting.DATAS')}</summary>
				{
					<pre>
						{
							parsed?.data ?
								JSON.stringify(parsed.data, null, 4)
								:
								"No Data"
						}
					</pre>
				}
			</details>
			<hr />
			<details>
				<summary>{t('Reporting.ERROR')}</summary>
				{
					<pre>
						{
							parsed?.error ?
								JSON.stringify(parsed.error, null, 4)
								:
								"No Data"
						}
					</pre>
				}
			</details>
		</div>
	);
}

// The report body is written by an external client: it carries the user as
// `employeeId`, or `EmployesId` for the clients still on the v1 format.
export function reportUserId(report, datas) {
	const temp = datas?.user?.tempValues;
	return temp ? (temp.employeeId ?? temp.EmployesId) : report.employeeId;
}

function UserPreview({ report, datas }) {
	let userId = reportUserId(report, datas);
	return (
		<div>
			<h5>{t('Reporting.USER')}</h5>
			{
				datas?.user?.tempValues &&
				<>
					<AuthorPreview
						employeeId={datas?.user.employeeId}
						format={
							[
								"firstName lastName / WFU",

							]
						}
						className="mb-2"
						modifiers={{
							lastName: (item) => item.toUpperCase()
						}}
					/>
					{t('Reporting.MSG1')}:
				</>
			}
			<AuthorPreview
				employeeId={userId}
				format={
					[
						"firstName lastName / WFU",

					]
				}
				className="mb-2"
				modifiers={{
					lastName: (item) => item.toUpperCase()
				}}
			/>

			<details>
				<summary>
					{t('Reporting.INFORMATIONS')}
				</summary>
				<pre>
					{
						datas?.user ?
							JSON.stringify(datas?.user, null, 4)
							:
							<InfosFetcher
								queryFn={() => genRequest("employees/" + userId)}
								queryKey={["Employes", userId]}
								treat={(a) => JSON.stringify(a, null, 4)}
							/>
					}
				</pre>
			</details>
		</div>
	);
}
